<div class="">

<div class="p-4 d-flex justify-content-between align-items-stretch">
        <h4 class="sectionTitle fw-semibold fs-5 m-0 text-uppercase text-center" translate>buy_stake_title</h4>
        <svg-icon src="./assets/images/svg-icons/burger-close.svg" [svgStyle]="{ 'width.px':20, 'height.px':20 }" class="cursor-pointer float-end" (click)="modalRef.hide()"></svg-icon>

  </div>

  <div class="payment-wrapper">

    <div class="p-1 swapArea"
    [ngClass]="{'cover': status === SwapStatus.in_progess || status === SwapStatus.confirm_pending || status === SwapStatus.approval_pending}">
    <p class="text-center mb-3 font-16 dashTitle fw-semibold" >1
      {{token}} = ${{salePrice}}</p>

    <div class="tab-container gap-2">
      <button class="btn btn-off-white font-16 text-uppercase d-flex align-items-center justify-content-center"
        [ngClass]="{'selected': swapMode ==='native'}" (click)="openSwap(true)" *ngIf="!isWeb3">
        <img src="./assets/images/svg-icons/{{isBsc ? 'bnb' : 'eth'}}.svg" height="22" alt="" />
        <span class="ps-2 font-16">{{isBsc ? "BNB" : "ETH" }}</span>
      </button>

      <button class="btn btn-off-white font-16 text-uppercase d-flex align-items-center justify-content-center"
        [ngClass]="{'selected': swapMode ==='usdt'}" (click)="openSwap(false)" *ngIf="!isWeb3">
        <img src="./assets/images/svg-icons/usdt.svg" height="22" alt="" />
        <span class="ps-2 font-16">USDT</span>
      </button>

      <!-- <button class="btn btn-off-white font-16 text-uppercase d-flex align-items-center justify-content-center"
        [ngClass]="{'selected': swapMode ==='card'}" (click)="openSwap(false, true)">
        <img src="./assets/images/svg-icons/card.svg" height="22" alt="" />
        <span class="ps-2 font-16" translate>card</span>
      </button> -->
    </div>

    <app-swap [isNative]="isNative" [isWert]="isWert" [buyStakeModal]="true" #swap></app-swap>

    <div class="mt-3">
        <!-- <button type="button" class="btn btn-black w-100 font-16 mt-2 cursor-pointer" *ngIf="!isWert && !isBsc"
        [disabled]="(isLowBalance) || !swapToken || swapToken == 0" (click)="confirm(true)"
        translate>buy_stake</button> -->

        <!-- <button type="button" class="btn btn-black w-100 font-16 mt-2 cursor-pointer" (click)="modalRef.hide()" translate>Close</button> -->
      <!-- <button class="btn btn-black font-16 mb-2 w-100" *ngIf="!walletAddress" (click)="connectWeb3Auth()" translate>connect_webauth</button> -->

      <p class="font-12 text-grey text-center mt-3" translate>powered_by <a
        href="https://web3paymentsolutions.io/" target="_blank"><img
          src="./assets/images/svg-icons/W3P_Black.svg" alt="" class="poweredByIcon"></a></p>

      <!-- <div class="font-16 mt-3 text-center">{{"private_sale_price" | translate: {salePrice: listPrice} }}</div> -->
    </div>
  </div>
  </div>
</div>
